import React from 'react';
import LegalPage from './LegalPage';

const SECTIONS = [
    {
        heading: '1. Information We Collect',
        body: 'When you create an account we collect information you provide, such as your name, email address, and optionally your phone number and institute. As you use Kobra Prep we also collect activity data such as test attempts, scores, favorites, and practice history so we can show your progress.',
    },
    {
        heading: '2. How We Use Your Information',
        body: 'We use your information to provide and improve the Service: to run tests and practice, track your statistics and streaks, personalize recommendations (such as weak-subject practice), process premium purchases, and communicate important updates.',
    },
    {
        heading: '3. Cookies and Local Storage',
        body: 'We use cookies and browser local storage to keep you signed in, remember your selected level, and store anonymous progress (such as recent tests and practice answers viewed) on your device. You can clear these at any time through your browser settings.',
    },
    {
        heading: '4. Payments',
        body: 'Premium payments are processed by third-party payment providers (e.g. bKash / SSLCommerz). We do not store your full payment credentials on our servers; that information is handled securely by the payment provider.',
    },
    {
        heading: '5. How We Share Information',
        body: 'We do not sell your personal information. We share data only with service providers who help us operate the platform (such as payment and email providers), or when required by law. Leaderboards may display your name and institute unless you choose to hide your institute in your profile settings.',
    },
    {
        heading: '6. Data Security',
        body: 'We use reasonable technical and organizational measures to protect your data, including hashed passwords and encrypted transport. No method of transmission or storage is completely secure, so we cannot guarantee absolute security.',
    },
    {
        heading: '7. Your Choices and Rights',
        body: 'You can review and update your profile information at any time, request deletion of your account, and opt out of non-essential communications. To make a request, contact us using the details below.',
    },
    {
        heading: '8. Data Retention',
        body: 'We retain your information for as long as your account is active or as needed to provide the Service and meet legal obligations. When no longer needed, data is deleted or anonymized.',
    },
    {
        heading: "9. Children's Privacy",
        body: 'Kobra Prep is intended for students preparing for exams. If you are under the age of majority in your country, please use the Service with the involvement of a parent or guardian.',
    },
    {
        heading: '10. Changes to This Policy',
        body: 'We may update this Privacy Policy from time to time. Significant changes will be reflected by the "Last updated" date above. Continued use of the Service constitutes acceptance of the updated policy.',
    },
];

export default function PrivacyPolicy() {
    return (
        <LegalPage
            title="Privacy Policy"
            updated="July 2026"
            intro="Your privacy matters to us. This policy explains what information Kobra Prep collects, how we use it, and the choices you have."
            sections={SECTIONS}
        />
    );
}
